import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { reset } from '../../../store/paySlice';
import { logout } from '../../../store/userSlice';

const useRequestRedwolfService = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const requestRedwolfService = (redwolfRequestPromise: any): Promise<any> => {
		return new Promise((resolve: any, reject: any) => {
			redwolfRequestPromise
				.then((response: any) => {
					if (
						(response.response && response.response.status && response.response.status === 401) ||
						(response.headers && response.headers.statusCode === 401) ||
						(response.internalErrorCode && response.internalErrorCode.name$ === 'UNAUTHORIZED') ||
						(response.response && response.response.message === 'access_denied') ||
						(response.headers && response.headers.statusCode === 403) ||
						response.constructor.$metadata$.simpleName === 'Unauthorized'
					) {
						dispatch(logout());
						dispatch(reset());
						navigate('/login', { replace: true });
					} else {
						resolve(response);
					}
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	};

	return [requestRedwolfService];
};

export default useRequestRedwolfService;
